import React from "react";
import styles from "./styles.module.css";
// import { BiLike, BiComment } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

const PostCard = ({ post }) => {
  const navigate = useNavigate();
  const onClickHandler = () => {
    navigate(`/post/${post._id}`, { state: post });
  };

  function removeHTMLTags(htmlString) {
    const doc = new DOMParser().parseFromString(htmlString, "text/html");
    return doc.body.textContent || "";
  }

  return (
    <div className={styles.card} onClick={onClickHandler}>
      <div className={styles.cardImage}>
        <img src={post?.images?.[0]} alt="Posts" />
      </div>
      <div className={styles.text}>
        <div className={styles.title}>
          <div className={styles.name}>
            <h6>
              {post?.title?.length > 30
                ? `${post?.title?.slice(0, 30)}...`
                : post?.title}
            </h6>
          </div>
        </div>
        <div className={styles.description}>
          <p
            dangerouslySetInnerHTML={{
              __html: removeHTMLTags(post.content)?.slice(0, 150),
            }}
          />
        </div>
        <div className={styles.prop}>
          <p>{new Date(post.createdAt).toLocaleString()}</p>
          {/* <div className={styles.propCont}>
            <span>
              <BiLike /> {post?.likes?.length}
            </span>
            <span>
              <BiComment /> {post?.comments?.length}
            </span>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default PostCard;
